<template>
    <Card :bordered="false" class="border-radius-0">
        <CTable :isLoading="isLoading"
                v-model:columns="data.columns"
                v-model:page="data.page"
                :options="data.tableOptions"
                :manages="data.manages"
                :manageExtras="data.manageExtras"
                :rowActions="data.rowActions"
                :visibleSearch="false"
                :clientSide="true"
                :canRefresh="false"
        ></CTable>
    </Card>
</template>

<script>
    import { reactive } from 'vue';
    import { Card } from 'ant-design-vue';
    import { defineComponent, defineAsyncComponent } from 'vue';
    import { initData, isLoading } from './physical-analysis-topic-table.logic';
    import { matchMenu } from '../../../../../utils/menu-context';
    import { state as stateApp } from '../../../../../app.logic';

    export default defineComponent({
        components: {
            Card,
            CTable: defineAsyncComponent(() => import('../../../../../components/table/CTable'))
        },
        props: {
            menuContext: { default: () => matchMenu('/app/lab-physic/sampling-product-analysis/exports', stateApp.authInfo.menus) },
            viewOnly: {},
            parent: {},
            useForm: {},
            dataProp: {},
            acceptStatus: {},
            repeatOption: {},
            conditionForms: {},
            itemsKey: {},
            fetchCriteria: {},
            visibleSearch: {
                default: true
            },
            refSamplingRequestTypeKey: {},
            refExtCenterTypeKey: {}
        },
        setup(props) {
            const refs = reactive({});
            const data = reactive({});
            initData({ props, data, refs });
            return { props, data, refs, isLoading };
        }
    });
</script>